import { CSSProperties } from 'react';

type StyleProps = {
    style?: CSSProperties;
};

const GoogleIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlGoogleIcon"
        width="16"
        height="16"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
    >
        <path
            d="M18 9.21583C18 8.608 17.94 7.98056 17.84 7.39233H9.17755V10.8629H14.1389C13.9389 11.9805 13.2787 12.9609 12.2984 13.5883L15.2592 15.8432C16.9997 14.2549 18 11.9413 18 9.21583Z"
            fill="#4280EF"
        />
        <path
            d="M9.17754 17.9999C11.6582 17.9999 13.7388 17.196 15.2592 15.8235L12.2984 13.5882C11.4782 14.1372 10.4179 14.4509 9.17754 14.4509C6.77688 14.4509 4.75632 12.8627 4.01611 10.7451L0.975266 13.0392C2.5357 16.0783 5.69658 17.9999 9.17754 17.9999Z"
            fill="#34A353"
        />
        <path
            d="M4.01611 10.7255C3.63601 9.60791 3.63601 8.39224 4.01611 7.27462L0.975271 4.96094C-0.32509 7.50991 -0.32509 10.5099 0.975271 13.0392L4.01611 10.7255Z"
            fill="#F6B704"
        />
        <path
            d="M9.17754 3.5689C10.4779 3.54929 11.7583 4.03948 12.6985 4.92182L15.3193 2.33363C13.6588 0.804248 11.4582 -0.0192653 9.17754 0.000342207C5.69658 0.000342207 2.5357 1.92187 0.975266 4.96103L4.01611 7.27471C4.75632 5.1375 6.77688 3.5689 9.17754 3.5689Z"
            fill="#E54335"
        />
    </svg>
);

const FacebookIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlFacebookIcon"
        width="16"
        height="16"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
    >
        <g clipPath="url(#clip0_542_288)">
            <path
                d="M24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 17.9895 4.8882 22.954 10.625 23.8542V15.4688H7.57812V12H10.625V9.35625C10.625 6.34875 12.4166 4.6875 15.1576 4.6875C16.4701 4.6875 17.8438 4.92188 17.8438 4.92188V7.875H16.3306C14.84 7.875 14.375 8.80008 14.375 9.75V12H17.7031L17.1711 15.4688H14.375V23.8542C20.1118 22.954 24.5 17.9895 24.5 12Z"
                fill="#0866FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_542_288">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

const InternalIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlInternalIcon"
        width="341"
        height="194"
        viewBox="0 0 341 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '24px', height: 'auto', ...style }}
    >
        <g clipPath="url(#clip0_37_113)">
            <path
                d="M0.708764 7.86068L102.687 192.02C104.219 194.677 108.057 194.656 109.56 191.982L140.982 128.775C141.649 127.587 141.659 126.138 141.007 124.941L105.491 59.72C104.055 57.0823 105.962 53.8673 108.964 53.8673H137.76C141.371 53.8673 144.728 55.7295 146.641 58.7949L161.855 83.1646C163.443 85.7095 167.173 85.6286 168.65 83.0172L212.265 5.90854C213.758 3.26976 211.853 0 208.824 0H5.24422C1.21375 0 -1.30568 4.36659 0.708764 7.86068Z"
                fill="#115CED"
            />
            <path
                d="M264.528 0C263.118 0 261.815 0.751173 261.107 1.97165L189.832 124.909C189.129 126.121 189.119 127.615 189.805 128.836L225.237 191.904C225.937 193.151 227.255 193.922 228.684 193.922H229.379C231.25 193.922 232.979 192.923 233.915 191.301L339.673 7.86067C341.687 4.36658 339.168 0 335.138 0H264.528Z"
                fill="#115CED"
            />
            <path
                d="M174.314 193.922C177.436 193.922 179.327 190.472 177.65 187.837L168.911 174.105C167.309 171.586 163.604 171.683 162.134 174.281L154.367 188.014C152.874 190.652 154.779 193.922 157.808 193.922H174.314Z"
                fill="#115CED"
            />
        </g>
        <defs>
            <clipPath id="clip0_37_113">
                <rect width="341" height="194" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const SourceIcon = ({
    source,
    style,
}: StyleProps & {
    source?: string;
}): JSX.Element | null => {
    switch (source) {
        case 'Facebook':
            return <FacebookIcon style={style} />;
        case 'GMB':
            return <GoogleIcon style={style} />;
        case 'Internal':
            return <InternalIcon style={style} />;
    }

    return null;
};
